import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import styles from './WarningBanner.module.scss';

interface WarningBannerProps {
    message: string;
}

const WarningBanner: React.FC<WarningBannerProps> = ({ message }) => {
    return (
        <div className={styles.container}>
            <span className={styles.icon}>
                <FiAlertTriangle />
            </span>
            <span className={styles.message}>{message}</span>
        </div>
    );
};

export default WarningBanner;
